import { useBreakpoints } from '@vueuse/core'
import { breakpoints as appBreakpoints } from '~/constants'

export const useBerkshireBreakpoints = (): {
  breakpoints: any
  atLeastMobile: Ref<boolean>
  atLeastTablet: Ref<boolean>
  atLeastDesktop: Ref<boolean>
  atLeastBigDesktop: Ref<boolean>
  isWide: Ref<boolean>
  isMobile: ComputedRef<boolean>
} => {
  const breakpoints = useBreakpoints(appBreakpoints)

  const atLeastMobile = breakpoints.greaterOrEqual('mobile')
  const atLeastTablet = breakpoints.greaterOrEqual('tablet')
  const atLeastDesktop = breakpoints.greaterOrEqual('desktop')
  const atLeastBigDesktop = breakpoints.greaterOrEqual('bigDesktop')

  const isWide = useMediaQuery('(min-width: 1440px)')
  const isMobile = computed<boolean>(() => {
    return !atLeastTablet.value
  })

  return {
    breakpoints,
    atLeastMobile,
    atLeastTablet,
    atLeastDesktop,
    atLeastBigDesktop,

    isWide,

    isMobile,
  }
}
